const CHAT_ALLOWED_EMAILS = [
  'elton.almeida@tjdft.jus.br',
  'marcio@marcio.com.br',
];

const normalizeEmail = (value: string | null | undefined): string => {
  return String(value || '').trim().toLowerCase();
};

export const canAccessChatArea = (user?: { role?: string; email?: string | null } | null): boolean => {
  if (!user) {
    return false;
  }

  if (user.role === 'SUPERADMIN') {
    return true;
  }

  if (!['ADMIN', 'TENANT_ADMIN'].includes(user.role || '')) {
    return false;
  }

  return CHAT_ALLOWED_EMAILS.includes(normalizeEmail(user.email));
};

export const getChatAllowedEmails = (): string[] => [...CHAT_ALLOWED_EMAILS];
